export default "__VITE_ASSET__C9uPzs4f__"